const HowWorksContent = {
  text: [
    'No credit checks',
    'No deposits or upfront fees',
    'Rent from 6 hours to 7 days.',
    'Book as many slots as you like',
    'Free cancellation 24 hours before',
    'Pay 2 hours before booking'
  ],
  para: [
    'Download the Autzu app and sign up',
    'Verify your identity and connect your rideshare account',
    'Schedule your bookings in advance',
    'Start your booking and inspect the vehicle through the Autzu app',
    'Control your vehicle and enjoy a contactless experience',
    'Contact our 24/7 support anytime'
  ]
};

export default HowWorksContent;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageLA/HowWorksContent.js